module.exports = __webpack_public_path__ + "img/02_rvn.3edf73ed.png";